export enum LocalStorageKeys {
    APP_CONFIG = 'appConfig',
    LOCALE = 'LOCALE',
    OIDC_OAUTH_TOKEN = 'OAUTH_TOKEN',
    REDIRECTION = 'REDIRECTION',
}
